import { gql } from '@apollo/client'

export default gql(`
    mutation updateRole($id: ID!, $name: String!, $project: String ) {
        updateRole(
            input: {
                name: $name
            },
            id: $id,
            project: $project
        ) {
            id
            name
            usedCount
        }
    }`
)
